export default __webpack_public_path__ + "static/media/certificate-card.f317fa6f.svg";